import React from 'react'
import moment from 'moment'
import { handleModalOpen } from '../Modal'
import { useAssetDeletion } from '../AssetActions/hooks/useAssetDeletion'
import { useFavoriteToggle } from '../hooks/useFavoriteToggle'
import { useUserInfo } from '../../Authentication/hooks'
import placeholderImg from '../../../assets/images/camera.jpg'
import favStar from '../../../assets/images/fav-star.svg'
import deleteImg from '../../../assets/images/delete2.svg'
import '../../../assets/stylesheets/duplicates.css'

const AssetThumbnail = ({
  asset,
  assetId,
  idx,
  state,
  dispatch,
  isLargeScreen,
  isSmallScreen,
  loadedImages,
  setLoadedImages
}) => {
  const { deleteAssetById } = useAssetDeletion()
  const { userId } = useUserInfo()
  const assetSrc = asset.thumbnailUrl
  const { isFavorited, toggleFavorite } = useFavoriteToggle({
    assetId,
    publishedAssets: state.publishedAssets,
    assetsArray: null,
    dispatchUpdate: dispatch
  })

  // Define responsive styles
  const largeScreenStyles = {
    width: '500px',
    height: '500px'
  }

  const getResponsiveStyles = () => {
    if (isLargeScreen) return largeScreenStyles
    if (isSmallScreen) return { width: '120px', height: '120px' }
    return { width: '200px', height: '200px' }
  }

  // Extract metadata date from each asset
  const metadataDate =
    asset.metadata && asset.metadata.content && asset.metadata.content.date
      ? moment(asset.metadata.content.date).format('DD MMMM YYYY')
      : 'Date not available'

  const handleThumbnailClick = () => {
    handleModalOpen({
      state: state,
      dispatch: dispatch,
      payload: {
        src: assetSrc,
        assetIdx: assetId
      }
    })
  }

  const handleImageLoad = () => {
    setLoadedImages(prevState => ({
      ...prevState,
      [assetId]: true
    }))
  }

  const handleDelete = (e) => {
    e.stopPropagation()
    const deletedAssetData = state.publishedAssets?.[assetId] || null
    const onSuccess = (deletedId) => {
      dispatch({ type: 'remove_asset', payload: deletedId })
    }
    const onUndo = (restoredId) => {
      if (deletedAssetData) {
        dispatch({ type: 'append_published_assets', payload: { [restoredId]: deletedAssetData } })
      }
    }
    deleteAssetById(assetId, userId, onSuccess, onUndo)
  }

  return (
    <div className="center-contents-block" key={'asset-' + idx}>
      <div
        className="gallery-thumb"
        id={`gallery-thumb-${idx}`}
        style={{
          backgroundImage: `url('${
            loadedImages[assetId] ? assetSrc : placeholderImg
          }')`,
          backgroundSize: loadedImages[assetId] ? 'cover' : '100%',
          backgroundRepeat: 'no-repeat',
          backgroundColor: loadedImages[assetId] ? 'transparent' : '#D9D9D9',
          ...getResponsiveStyles()
        }}
        onClick={handleThumbnailClick}
      >
        {isFavorited && (
          <button
            className="thumb-fav-star"
            onClick={(e) => { e.stopPropagation(); toggleFavorite() }}
            title="Unfavorite"
          >
            <img src={favStar} alt="Favorited" />
          </button>
        )}
        <button
          className="thumb-action-overlay"
          onClick={handleDelete}
          title="Delete"
        >
          <img src={deleteImg} alt="Delete" />
        </button>
        <div className="date-overlay">{metadataDate}</div>
        <img
          src={assetSrc}
          alt=""
          style={{ display: 'none' }}
          onLoad={handleImageLoad}
        />
      </div>
    </div>
  )
}

export default AssetThumbnail
